/**
 * Primary SEO copy (keep in sync with public/index.html head tags).
 */
export const SEO_TITLE =
  'Cure8 Studios | AI Automation, Agentic Workflows & GTM Intake';

export const SEO_DESCRIPTION =
  'Cure8 Studios: AI automation and agentic workflows for owner-operated businesses. Fix GTM intake, follow-up, and operations—workflow audits, diagnosis, and delivery in weeks.';
